import { sessionState } from 'src/app/core/services/signal-state.storage';
import { Component, OnInit, ViewChild } from '@angular/core';
import { UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { MatStepper } from '@angular/material/stepper';
import { ActivatedRoute, Router } from '@angular/router';
import { Subject } from 'rxjs/internal/Subject';
import { AppService } from 'src/app/app.service';
import { IAcctDetail } from 'src/app/gdo/gdo-shared/Models/Interfaces';
import { packageCardDetails } from 'src/app/gdo/gdo-shared/Models/Models';
import { GdoVehicleService } from '../../gdo-vehicle.service';
import { GdoSubscriptionContactInformationComponent } from './gdo-subscription-contact-information/gdo-subscription-contact-information.component';
import { GdoSubscriptionCreatePinComponent } from './gdo-subscription-create-pin/gdo-subscription-create-pin.component';
import { STEPPER_GLOBAL_OPTIONS } from '@angular/cdk/stepper';
@Component({
  selector: 'app-gdo-manage-subscription',
  templateUrl: './gdo-manage-subscription.component.html',
  styleUrls: ['./gdo-manage-subscription.component.scss'],
  providers: [{
    provide: STEPPER_GLOBAL_OPTIONS,
    useValue: { displayDefaultIndicatorType: false }
  }],
  standalone: false
})
export class GdoManageSubscriptionComponent implements OnInit {
  @ViewChild('stepper') private myStepper!: MatStepper;
  scrollElement: any
  isLinear = false;
  title = 'Purchase Subscription';
  subscriptionForm!: UntypedFormGroup;
  data!: IAcctDetail;
  formData = null;
  currentSelectedPackage!: packageCardDetails;
  parentSubject: Subject<any> = new Subject();
  showResetPin: boolean = false

  validators = [
    this.service.ConfirmPin,
    this.service.PinValidation
  ];

  contactInfoValidators = [
    this.service.nameValidation,
    this.service.phoneNoValidation,
    this.service.zipCodeValidation,
    this.service.cityAddressValidation
  ];


  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private _myVehicleService: GdoVehicleService,
    private service: AppService
  ) { }

  ngAfterViewInit(): void {
    if (this.service.getSubsSelectedPackage() && this.service.getSubsContactInfo()) {
      this.myStepper.selectedIndex = 1
      this.myStepper.next()
    }
  }

  ngOnInit() {
    this.data = this.service.getAccDetails();
    this.currentSelectedPackage = this.service.getCurrentPackgDetails();
    let subsSelectedPackage = this.service.getSubsSelectedPackage()
    let subsContactDetails = this.service.getSubsContactInfo()
    //has a package value
    
    //null
    
    this.subscriptionForm = new UntypedFormGroup({
      packageDetails: new UntypedFormGroup({
        availablePackageSelection: new UntypedFormControl(subsSelectedPackage, Validators.required),
      }),
      contactDetails: new UntypedFormGroup({
        first_name: new UntypedFormControl(subsContactDetails ? subsContactDetails.first_name : this.data?.firstName, Validators.required),
        last_name: new UntypedFormControl(this.data?.lastName, Validators.required),
        phone: new UntypedFormControl(subsContactDetails ? convertToUsFormat(subsContactDetails.phone) : convertToUsFormat(this.data?.phone), [
          Validators.required,
          Validators.minLength(9)
        ]),
        mobile_prov: new UntypedFormControl(subsContactDetails ? subsContactDetails.mobile_prov : ''),
        cell_phone: new UntypedFormControl(subsContactDetails ? convertToUsFormat(subsContactDetails.cell_phone) : convertToUsFormat(this.data?.cellPhone)),
        country_cd: new UntypedFormControl(subsContactDetails ? subsContactDetails.country_cd : this.data?.countryCode),
        email: new UntypedFormControl({ value: this.data?.email, disabled: true }, [
          Validators.required,
          Validators.email,
        ]),
        businessName: new UntypedFormControl(subsContactDetails ? subsContactDetails.businessName : null),
        locale_name: new UntypedFormControl(subsContactDetails ? subsContactDetails.locale_name : this.data?.acctLocaleName),
        addressLine1: new UntypedFormControl(subsContactDetails ? subsContactDetails.addressLine1 : this.data?.address1, Validators.required),
        addressLine2: new UntypedFormControl(subsContactDetails ? subsContactDetails.addressLine2 : this.data?.address2),
        city: new UntypedFormControl(subsContactDetails ? subsContactDetails.city : this.data?.city, Validators.required),
        state_prov: new UntypedFormControl(subsContactDetails ? subsContactDetails.state_prov : this.data?.stateProv, Validators.required),
        postal_cd: new UntypedFormControl(subsContactDetails ? subsContactDetails.postal_cd : this.data?.postalCode, Validators.required),
      },
        this.contactInfoValidators
      ),

      paymentDetails: new UntypedFormGroup({
        availablePaymentMethodSelection: new UntypedFormControl(
          null,
          Validators.required
        ),
      }),
      pinDetails: new UntypedFormGroup({
        // newPin: new FormControl(null, [Validators.required, Validators.minLength(4), Validators.maxLength(4), Validators.pattern(/^(?!(.)\1{3})(?!19|20)(?!0123|1234|2345|3456|4567|5678|6789|7890|0987|9876|8765|7654|6543|5432|4321|3210)\d{4}$/)]),
        // confirmPin: new FormControl(null, [Validators.required, Validators.minLength(4), Validators.maxLength(4), Validators.pattern(/^(?!(.)\1{3})(?!19|20)(?!0123|1234|2345|3456|4567|5678|6789|7890|0987|9876|8765|7654|6543|5432|4321|3210)\d{4}$/)]),
        newPin: new UntypedFormControl(null, [Validators.required, Validators.minLength(4), Validators.maxLength(4)]),
        confirmPin: new UntypedFormControl(null, [Validators.required, Validators.minLength(4), Validators.maxLength(4)]),
      },
        this.validators),
    });

    this.title = sessionState.getItem("titleSubscription") ?? this.title;

    let resetPin = sessionState.getItem("showResetPin")
    if (resetPin == "false") {
      this.showResetPin = false
    } else {
      this.showResetPin = true
    }



    // this.route.queryParamMap.subscribe((snap: any) => {
    //   if (snap && snap.params) {
    //     this.title = snap.params.title;
    //   }
    // });
  }

  onCancel() {
    this.router.navigate(['/gdo-product']);
  }

  onConfirmPurchase() {
    this._myVehicleService.setSubscriptionStatus(true);
    this.router.navigate(['/gdo-product']);
  }
  notifyChildren() {
    this.parentSubject.next('some value');
  }

  public onStepChange(event: any): void {
    //   let maxIndex = 3;
    //   if (this.title == 'Purchase Subscription' && this.showResetPin) {
    //     maxIndex = 4;
    //   }
    //   if (event.selectedIndex == maxIndex) {
    //     this.notifyChildren();
    //   }
    //   
    // }
    let systemType = sessionState.getItem("systemType")
    let maxIndex = 3;
    if (this.title == 'Purchase Subscription' && this.showResetPin) {
      maxIndex = 4;
    }
    if (event.selectedIndex == maxIndex) {
      this.notifyChildren();
    }
    // 

    

    if (event.selectedIndex == 0) {

      setTimeout(() => {
        this.scrollElement = document.getElementById("subsSelect");
        if (this.scrollElement !== null) {
          this.scrollElement.scrollIntoView()
        }
        //this.scrollElement.scrollTo(-200,0)
      }, 300);
    }
    if (event.selectedIndex == 1) {
      setTimeout(() => {
        this.scrollElement = document.getElementById("contactInfo");
        if (this.scrollElement !== null) {
          this.scrollElement.scrollIntoView()
        }
        //this.scrollElement.scrollTo(-200,0)
      }, 300);
    }
    if (event.selectedIndex == 2) {
      setTimeout(() => {
        this.scrollElement = document.getElementById("paymentMethod");
        if (this.scrollElement !== null) {
          this.scrollElement.scrollIntoView()
        }
      }, 300);
    }
    if (maxIndex === 4) {
      if (event.selectedIndex == 3) {
        setTimeout(() => {
          this.scrollElement = document.getElementById("createPin");
          if (this.scrollElement !== null) {
            this.scrollElement.scrollIntoView()
          }
        }, 300);
      }
      if (systemType == "ios") {
        if (event.selectedIndex == 4) {
          setTimeout(() => {
            
            this.scrollElement = document.getElementById("summary");
            //this.scrollElement.scrollIntoView()
            if (this.scrollElement !== null) {
              this.scrollElement.scrollIntoView()
            }
          }, 300);
        }
      }
      else {
        if (event.selectedIndex == 4) {
          setTimeout(() => {
            
            this.scrollElement = document.getElementById("summary");
            if (this.scrollElement !== null) {
              this.scrollElement.scrollIntoView()
            }
            //this.scrollElement.scrollTo(500, 0)
          }, 300);
        }
      }

    }
    if (maxIndex === 3) {
      if (systemType == "ios") {
        if (event.selectedIndex == 3) {
          setTimeout(() => {
            
            this.scrollElement = document.getElementById("summary");
            //this.scrollElement.scrollIntoView()
            if (this.scrollElement !== null) {
              this.scrollElement.scrollIntoView()
            }
          }, 300);
        }
      }
      else {
        if (event.selectedIndex == 3) {
          setTimeout(() => {
            
            this.scrollElement = document.getElementById("summary");
            if (this.scrollElement !== null) {
              this.scrollElement.scrollIntoView()
            }
            //this.scrollElement.scrollTo(500, 0)
          }, 300);
        }
      }


    }

    //window.scrollTo(200,0)
  }

}
function convertToUsFormat(phone: string | undefined): string | null {
  if (phone) {
    phone = phone.replace(/[^\d]/g, "");
    return phone.replace(/(\d{0,3})(\d{0,3})(\d{0,4})/, "($1) $2-$3");
  }
  else {
    return null;
  }
}
